/* tslint:disable */
/* eslint-disable */

import { ReaderInlineDataFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type messageHelpers_messages = {
    readonly items: ReadonlyArray<{
        readonly note: {
            readonly content: {
                readonly message: string | null;
            } | null;
            readonly anchors: ReadonlyArray<{
                readonly content: {
                    readonly message: string | null;
                } | null;
            } | null> | null;
        } | null;
    } | null> | null;
    readonly " $refType": "messageHelpers_messages";
};
export type messageHelpers_messages$data = messageHelpers_messages;
export type messageHelpers_messages$key = {
    readonly " $data"?: messageHelpers_messages$data;
    readonly " $fragmentRefs": FragmentRefs<"messageHelpers_messages">;
};



const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "messageHelpers_messages"
};
(node as any).hash = '2fd9714c7a64d80b58d143c8191d95bf';
export default node;
